import { render } from "./subTopicManager.vue?vue&type=template&id=bca1c734&scoped=true"
import script from "./subTopicManager.vue?vue&type=script&lang=js"
export * from "./subTopicManager.vue?vue&type=script&lang=js"

import "./subTopicManager.vue?vue&type=style&index=0&id=bca1c734&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bca1c734"]])

export default __exports__